<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Sikkerhed</mat-panel-title>
  </mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">

      <!-- GENERAL -->
      <dl fxFlex="30" class="settings-list">
        <dt>Login låst til IP-adresse</dt>
        <dd>{{value.skip_ip_check ? 'Nej' : 'Ja'}}</dd>
        <dt>Modtager sikkerheds notifikationer</dt>
        @if (!value.mail?.length) {
          <dd>Brugere med samme rettighed.</dd>
        }
        @for (m of value.mail; track m) {
          <dd>{{m}}</dd>
        }
      </dl>
      <mat-divider [vertical]="true"></mat-divider>

      <!-- ANTI VIRUS -->
      <dl fxFlex="30" class="settings-list">
        <dt>Modtager anti-virus notifikationer</dt>
        <dd>{{value.anti_virus.mail || '-' }}</dd>
      </dl>
      <mat-divider [vertical]="true"></mat-divider>

      <!-- HAZARDOUS FILE -->
      <dl fxFlex="30" class="settings-list">
        <dt>Modtager farilgfil notifikationer</dt>
        <dd>{{value.hazardous_file.mail || '-' }}</dd>
        <dt>Notifikation til sagsbehandler ved upload af farligfil?</dt>
        <dd>{{value.hazardous_file.notifications.user ? 'Ja' : 'Nej'}}</dd>
        <dt>Notifikation til ansøger ved upload af farligfil?</dt>
        <dd>{{value.hazardous_file.notifications.profile ? 'Ja' : 'Nej'}}</dd>
        <dt>Tilladte filtyper</dt>
        @if (value.hazardous_file.allowed_types.length < 1) {
          <dd>Alle</dd>
        } @else {
          @for (type of value.hazardous_file.allowed_types; track type) {
            <dd>{{type}}</dd>
          }
        }
      </dl>
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form">
      <div fxLayout="row" fxLayoutAlign="space-between" class="mb-3">

        <!-- GENERAL -->
        <div fxFlex="30" fxLayout="column">
          <p>Hvis deaktiveret kan samme login bruges på tværs af IP-adresser.</p>
          <mat-checkbox ngDefaultControl formControlName="skip_ip_check">Deaktiver login IP-kontrol.</mat-checkbox>
          <p>Ved ændring i væsentlige rettigheder notificeres brugere med retten til at ændre brugeropsætning - med mindre der er angivet en eller flere emailadresser, som skal modtage sikkerhedsnotifikationer.</p>
          @for (_ of mails.controls; track _; let i = $index) {
            <div fxLayout="row" fxLayoutAlign="start center">
              <mat-form-field>
                <mat-label>E-mail</mat-label>
                <input
                  type="email"
                  matInput
                  [formControl]="mailAt(i)"
                />
              </mat-form-field>
              <button
                mat-icon-button
                matTooltip="Slet e-mail"
                (click)="doRemoveMail(i)"
              ><mat-icon>delete</mat-icon></button>
            </div>
          }
          <div>
            <button
              mat-stroked-button
              matTooltip="Tilføj e-mail"
              (click)="doAddMail()"
            >Tilføj e-mail</button>
          </div>
        </div>

        <!-- ANTI VIRUS -->
        <div fxFlex="30" fxLayout="column">
          <p>Modtager anti-virus notifikationer</p>
          <mat-form-field>
            <mat-label>E-mail</mat-label>
            <input
              type="email"
              matInput
              [formControl]="form.controls.anti_virus.controls.mail"
            />
          </mat-form-field>
        </div>

        <!-- HAZARDOUS FILE -->
        @let hazardous_controls = form.controls.hazardous_file.controls;
        @let hazardous_notifications = hazardous_controls.notifications.controls;
        <div fxFlex="30" fxLayout="column">
          <p>Modtager farilgfil notifikationer</p>
          <mat-form-field>
            <mat-label>E-mail</mat-label>
            <input
              type="email"
              matInput
              [formControl]="hazardous_controls.mail"
            />
          </mat-form-field>
          <p>Notifikation til sagsbehandler ved upload af farligfil?</p>
          <mat-checkbox ngDefaultControl [formControl]="hazardous_notifications.user">Aktiveret</mat-checkbox>
          <p>Notifikation til ansøger ved upload af farligfil?</p>
          <mat-checkbox ngDefaultControl [formControl]="hazardous_notifications.profile">Aktiveret</mat-checkbox>
          <p>Tilladte filtyper. Hvis intet er sat, accepteres alle filtyper</p>
          @for (type of hazardous_controls.allowed_types.controls; track type) {
            <div fxLayout="row" fxLayoutAlign="start center">
              <mat-form-field class="mb-1 w-100">
                <mat-label>Filtype (Regex)</mat-label>
                <input
                  type="text"
                  matInput
                  [formControl]="type"
                />
                @if (type.hasError('regexable')) {
                  <mat-error>Regex invalid: {{type.errors.regexable}}</mat-error>
                } @else if (type.hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
              </mat-form-field>
              <button
                mat-icon-button
                matTooltip="Fjern filtype"
                (click)="removeAllowedType($index)"
              ><mat-icon>delete</mat-icon></button>
            </div>
          }
          <div>
            <button
              mat-stroked-button
              matTooltip="Tilføj filtype"
              (click)="addAllowedType()"
            >Tilføj filtype</button>
          </div>
        </div>
      </div>
    </form>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button (click)="doCancel()">Fortryd</button>
        <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
